var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancel = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-8686-33.065a1.1,1.1,0,0,1,.327-.774l6.151-6.17-6.151-6.151a1.119,1.119,0,0,1-.327-.776A1.051,1.051,0,0,1-8684.954-48a1,1,0,0,1,.729.305l6.223,6.239,6.224-6.239a.986.986,0,0,1,.727-.305A1.051,1.051,0,0,1-8670-46.935a1.126,1.126,0,0,1-.325.776l-6.151,6.151,6.151,6.168a1.107,1.107,0,0,1,.325.776A1.051,1.051,0,0,1-8671.052-32a.986.986,0,0,1-.727-.305L-8678-38.553l-6.223,6.247a.993.993,0,0,1-.729.307A1.052,1.052,0,0,1-8686-33.065Z",
    transform: "translate(8686.503 48.499)",
    fill: "#788e9f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cancel.2bec3952b4a5fd61a6a45ee089fe30be.svg";